<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon" class="mr-2"/> {{ caption }} </span>
        <div class="card-header-actions">
          Total : {{item.length}}
        </div>

      </CCardHeader>
      <CCardBody>
        <CDataTable
            :table-filter="{label:$t('search')}"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="fields"
            :items-per-page="small ? 50 : 20"
            :dark="dark"
            pagination
            :loading="loading"
            sorter
        >
          <template #index="{item,index}">
            <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
          </template>

          <template #isTalent="{ item, index}">
            <td class="text-center" > {{ (item.isTalent == true)?$t('gap.found'):$t('gap.notFound') }}</td>
          </template>



          <template #action="{item,index}">
            <td style="width: 140px">
              <CRow>
                <CCol class="text-center">
<!--                  <CButton class="mr-1" v-c-tooltip="{content: $t('tooltip.detail') }" size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >-->
<!--                    <CIcon name="cil-description"/>-->
<!--                  </CButton>-->
                  <CButton class="mr-1" v-c-tooltip="{content: $t('tooltip.assessment') }"  size="sm" color="dark" shape="pill" variant="outline" @click="onChangeAssessment(item, index)"  >
                    <CIcon name="cil-people"/>
                  </CButton>

                </CCol>
              </CRow>
            </td>
          </template>


        </CDataTable>
      </CCardBody>
    </CCard>
    <SearchProfile :is-show="isDialog" :is-select-account="true" @update="onDismiss" :object="nodeData" @select-account="changeAssessment"/>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
import SearchProfile from "@/projects/components/Dialog/SearchProfile.vue";
import Organization from "@/projects/views/E-Performances/Organization/index.vue";

export default {
  name: 'History_IDP',
  components: {Organization, SearchProfile},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    fields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
          {key:"accounts", label:"Name"},
          {key:"assessor", label:"Assessor"},
          // {key:"isTalent", label: "Talent", _style: 'width:120px; text-align: center'},
          {key:"state", label:"Status",_style: 'width:150px; text-align: center'},
          {key:"action", label: "#", _style: 'width:40px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    loading: Boolean,
  },

  data: function () {
    return {
      isDialog: false,
      collapseDuration: 0,

      nodeData:{
        children:[]
      },

      prepare:{},
      items:[]
    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

    },
    onDismiss(){
      this.isDialog = false;
    },

    onChangeAssessment(item,index) {
      console.log(123,item)
      this.isDialog = true;
      this.prepare = item;
    },

    changeAssessment(item, index) {
      this.isDialog = false;

      var body = {};
      body._id = this.prepare.id;
      body.assessor = item.value._id;

      this.$store.dispatch("idp/changeAssessor", body)
    },


    onChangeLanguage(){
      this.item = this.plans.map(item => ({
        id: item._id,
        code: item.accounts.accounts.code,
        position: item.position.agency.title.find(t => t.key === 'th').value,
        info: item.accounts.accounts.userinfo.prefix.find(t => t.key === 'th').value + " " + item.accounts.accounts.userinfo.firstName.find(t => t.key === 'th').value + " " + item.accounts.accounts.userinfo.lastName.find(t => t.key === 'th').value,
        status: item.status.at(-1).state.title.find(t => t.key === 'th').value,
        isTalent: item.isTalent,
        assessor: item.assessor.accounts.accounts.userinfo.prefix.find(t => t.key === 'th').value + " " + item.assessor.accounts.accounts.userinfo.firstName.find(t => t.key === 'th').value + " " + item.assessor.accounts.accounts.userinfo.lastName.find(t => t.key === 'th').value,
      }));
    }


  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      plans: "report/plans",
      item: "report/members",
    })
  },

  watch: {
    lang(value){
      this.onChangeLanguage();
    },
    plans(value){
      this.onChangeLanguage();
    },

    item(value){

      var lang = this.$store.getters['setting/lang']
      this.items = value.map(history => ({
        ...history,

        id: history._id,
        code: history.accounts?.accounts?.code,
        accounts:history.accounts?.accounts?.userinfo.prefix.filter(objs => { return objs.key === lang })[0].value+' '+history.accounts?.accounts?.userinfo.firstName.filter(objs => { return objs.key === lang })[0].value+' '+history.accounts?.accounts?.userinfo.lastName.filter(objs => { return objs.key === lang })[0].value,
        assessor:history.assessor.accounts?.accounts?.userinfo.prefix.filter(objs => { return objs.key === lang })[0].value+' '+history.assessor.accounts?.accounts?.userinfo.firstName.filter(objs => { return objs.key === lang })[0].value+' '+history.assessor.accounts?.accounts?.userinfo.lastName.filter(objs => { return objs.key === lang })[0].value,

        state:history.status?.at(-1).state.title.filter(objs => { return objs.key === lang })[0].value,
        status:history.status?.at(-1).state,
      }))

    }
  }
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
